import { Component, Input, OnInit } from '@angular/core';
import { ModalNavigationComponent } from '../../../../services/gui/modal/modal-navigation-component';
import { API, DeviceFullDTO, LocalDataScope } from '../../../../services/api/api';
import { ModalNavigationService } from '../../../../services/gui/modal/modal-navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService, ToastType } from '../../../../services/toaster/toaster.service';

interface ScopeOptions {
  scope: LocalDataScope;
  selected: boolean;
}

@Component({
  selector: 'sb-device-local-data',
  templateUrl: './sb-device-local-data.component.html',
  styleUrls: ['./sb-device-local-data.component.scss'],
  standalone: false,
})
export class SbDeviceLocalDataComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  @Input() device: DeviceFullDTO;

  allScopeOptions: ScopeOptions[];

  constructor(
    public api: API,
    public modalNavigation: ModalNavigationService,
    public translate: TranslateService,
    public toaster: ToasterService
  ) {
    this.allScopeOptions = Object.keys(LocalDataScope).map(scope => {
      return { scope: LocalDataScope[scope], selected: false };
    });
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.device = this.modalNavigation.getCurrentNavigation().data.device;
    }
  }

  submit() {
    this.api
      .ss_nm_Device_executeCommandClearLocalData(this.device.id, {
        scope: this.allScopeOptions
          .filter(scope => scope.selected)
          .map(scope => {
            return scope.scope;
          }),
      })
      .subscribe({
        next: () => {
          this.toaster.toast(ToastType.SUCCESS, this.translate.instant('lang.globals.successful'));
        },
        error: () => {
          this.toaster.toast(ToastType.DANGER, this.translate.instant('lang.globals.error'));
        },
      });
    this.goBack();
  }

  reject() {
    this.goBack();
  }

  goBack() {
    this.modalNavigation.goBack();
  }
}
